const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the myreports component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('dynicon', ['Application', function (Application) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      icon: '=?',
      location: '=?',
      strokeColor: '=?',
      x: '=?',
      y: '=?'
    },
    template: require('../../templates/directives/dynicon.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.brandColor = $scope.strokeColor || Application.COLORS[0];
      self.activeIcon = $scope.icon;
      //preset locations
      let locations = {
        "dashboard": {
          x: '28px',
          y: '1.5rem'
        },
        "journey": {
          x: '2.5rem',
          y: '2.5rem'
        }
      }
      self.dimensions = {
        x: '1rem',
        y: '1rem',
      }
      if ($scope.location && locations[$scope.location]) {
        self.dimensions = locations[$scope.location];
      }
      if ($scope.x) {
        self.dimensions.x = $scope.x;
      }
      if ($scope.y) {
        self.dimensions.y = $scope.y;
      }
    }],
    controllerAs: 'dynicon'
  };
}]);
